(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_carousel-content"] && !Shopify.designMode) return;
  try {
    (() => {
    const check = () => {
      document.querySelectorAll('[data-review]:not(.mc-review--open)').forEach((review) => {
        const text = review.querySelector('[data-review-text]');
        const more = review.querySelector('[data-review-more]');
        if (!text || !more) return;
        review.classList.add('mc-review--clamped');
        more.hidden = text.scrollHeight <= text.clientHeight + 1;
        if (more.hidden) review.classList.remove('mc-review--clamped');
      });
    };
    const num = (card, key) => parseFloat(card.dataset[key]) || 0;
    const sorters = {
      pos: (a, b) => num(a, 'mcPos') - num(b, 'mcPos'),
      date: (a, b) => num(b, 'mcDate') - num(a, 'mcDate'),
      high: (a, b) => num(b, 'mcRating') - num(a, 'mcRating') || num(b, 'mcDate') - num(a, 'mcDate'),
      low: (a, b) => num(a, 'mcRating') - num(b, 'mcRating') || num(b, 'mcDate') - num(a, 'mcDate'),
    };
    const sortCards = (select) => {
      const block = select.closest('.mc-reviews-sort').nextElementSibling;
      return block ? [...block.querySelectorAll('[data-mc-pos]')] : [];
    };
    const hideUselessSort = () => {
      document.querySelectorAll('[data-mc-review-sort]').forEach((select) => {
        const cards = sortCards(select);
        const order = [...cards].sort(sorters.pos);
        const changes = cards.length > 1 && ['date', 'high', 'low'].some((key) => [...cards].sort(sorters[key]).some((card, index) => card !== order[index]));
        select.closest('.mc-reviews-sort').hidden = !changes;
      });
    };
    document.addEventListener('change', (event) => {
      const select = event.target.closest('[data-mc-review-sort]');
      if (!select) return;
      const cards = sortCards(select);
      if (cards.length < 2) return;
      const parent = cards[0].parentElement;
      cards.sort(sorters[select.value] || sorters.pos).forEach((card) => parent.appendChild(card));
      const scroller = parent.closest('slideshow-slides') || parent;
      scroller.scrollTo({ left: 0, behavior: 'auto' });
      later();
    });
    document.addEventListener('click', (event) => {
      const more = event.target.closest('[data-review-more]');
      if (!more) return;
      const review = more.closest('[data-review]');
      review.classList.remove('mc-review--clamped');
      review.classList.add('mc-review--open');
      more.hidden = true;
    });
    let timer;
    const later = () => {
      clearTimeout(timer);
      timer = setTimeout(check, 150);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', check);
      document.addEventListener('DOMContentLoaded', hideUselessSort);
    } else {
      check();
      hideUselessSort();
    }
    document.addEventListener('shopify:section:load', hideUselessSort);
    window.addEventListener('load', check);
    window.addEventListener('resize', later);
    if (document.fonts) document.fonts.ready.then(check);
    document.addEventListener('shopify:section:load', later);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-pmg-zoom]');
      if (!button) return;
      event.preventDefault();
      const container = button.closest('slideshow-container');
      const scroller = container && container.querySelector('slideshow-slides');
      if (!scroller) return;
      const box = scroller.getBoundingClientRect();
      const center = box.left + box.width / 2;
      const slides = [...scroller.children].filter((slide) => slide.offsetParent !== null);
      const current =
        slides.find((slide) => {
          const rect = slide.getBoundingClientRect();
          return rect.left <= center && rect.right >= center;
        }) || slides[0];
      if (current) current.click();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cover-toggle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cover-toggle')) {
  customElements.define(
    'cover-toggle',
    class CoverToggle extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-ctg-input]');
        if (!this.input) return;
        this.onChange = () => this.update();
        this.input.addEventListener('change', this.onChange);
      }
      disconnectedCallback() {
        if (this.input) this.input.removeEventListener('change', this.onChange);
      }
      gallery() {
        const card = this.closest('product-card') || this.closest('.product-card') || this.parentElement;
        return card ? card.querySelector('.card-gallery') : null;
      }
      update() {
        const gallery = this.gallery();
        if (!gallery) return;
        let overlay = gallery.querySelector(':scope > .ctg-overlay');
        if (!overlay) {
          const template = this.querySelector('[data-ctg-image]');
          if (!template) return;
          gallery.appendChild(template.content.cloneNode(true));
          overlay = gallery.querySelector(':scope > .ctg-overlay');
          if (!overlay) return;
          void overlay.offsetWidth;
        }
        overlay.classList.toggle('is-visible', this.input.checked);
      }
    }
  );
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["creator-card"] && !Shopify.designMode) return;
  try {
    (() => {
    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-creator-follow-toggle]');
      if (!toggle) return;
      const form = toggle.closest('.creator-card').querySelector('[data-creator-follow]');
      if (!form) return;
      form.hidden = !form.hidden;
      if (!form.hidden) form.querySelector('input').focus();
    });
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-creator-follow]');
      if (!form) return;
      event.preventDefault();
      const message = form.querySelector('[data-creator-follow-message]');
      const script = [...document.scripts].find((item) => /klaviyo\.js\?company_id=/.test(item.src));
      const companyId = script ? new URL(script.src).searchParams.get('company_id') : null;
      const email = form.querySelector('input').value.trim();
      if (!companyId || !email) {
        message.textContent = message.dataset.error;
        return;
      }
      const creator = form.dataset.creator;
      const body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: `Follow creator: ${creator}`,
            profile: {
              data: {
                type: 'profile',
                attributes: { email, properties: { followed_creator: creator } },
              },
            },
          },
          relationships: { list: { data: { type: 'list', id: form.dataset.list } } },
        },
      };
      try {
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${companyId}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
          body: JSON.stringify(body),
        });
        message.textContent = response.ok ? message.dataset.success.replace('[creator]', creator) : message.dataset.error;
      } catch (error) {
        message.textContent = message.dataset.error;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["focus-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('focus-slider')) {
  customElements.define(
    'focus-slider',
    class FocusSlider extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-fsl-viewport]');
        this.track = this.querySelector('[data-fsl-track]');
        if (!this.viewport || !this.track) return;
        this.originals = Array.from(this.track.querySelectorAll(':scope > [data-fsl-slide]'));
        this.count = this.originals.length;
        if (!this.count) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        if (this.count > 1) this.buildClones();
        this.slides = Array.from(this.track.querySelectorAll(':scope > [data-fsl-slide]'));
        const start = Math.min(Math.max(parseInt(this.dataset.start, 10) || 0, 0), this.count);
        const startIndex = start > 0 ? start - 1 : Math.floor(this.count / 2);
        this.index = this.count > 1 ? this.count + startIndex : 0;
        this.go(this.index, false);
        this.track.addEventListener('transitionend', (event) => {
          if (event.target === this.track && event.propertyName === 'transform') this.normalize();
        }, { signal });
        window.addEventListener('resize', () => this.go(this.index, false), { signal });
        if (this.dataset.clickSelect === 'true') {
          this.track.addEventListener('click', (event) => this.onClick(event), { signal });
        }
        if (this.dataset.swipe === 'true' && this.count > 1) this.bindSwipe(signal);
        this.autoplayMs = (parseInt(this.dataset.autoplay, 10) || 0) * 1000;
        if (this.dataset.pauseHover === 'true') {
          this.addEventListener('mouseenter', () => this.pause(), { signal });
          this.addEventListener('mouseleave', () => this.play(), { signal });
        }
        this.addEventListener('focusin', () => this.pause(), { signal });
        this.addEventListener('focusout', () => this.play(), { signal });
        document.addEventListener('visibilitychange', () => (document.hidden ? this.pause() : this.play()), { signal });
        document.addEventListener('shopify:block:select', (event) => this.onEditorSelect(event), { signal });
        document.addEventListener('shopify:block:deselect', () => this.play(), { signal });
        this.play();
      }
      disconnectedCallback() {
        this.pause();
        if (this.abort) this.abort.abort();
      }
      buildClones() {
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();
        this.originals.forEach((slide) => {
          before.appendChild(this.cloneSlide(slide));
          after.appendChild(this.cloneSlide(slide));
        });
        this.track.prepend(before);
        this.track.append(after);
      }
      cloneSlide(slide) {
        const clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
        return clone;
      }
      metrics() {
        const first = this.slides[0];
        const styles = getComputedStyle(this.track);
        const width = first.offsetWidth;
        const gap = parseFloat(styles.columnGap) || 0;
        const scale = parseFloat(getComputedStyle(this).getPropertyValue('--fsl-cur-scale')) || 1;
        return { width, gap, extra: (width * (scale - 1)) / 2 };
      }
      offsetFor(index, drag = 0) {
        const { width, gap, extra } = this.metrics();
        const center = index * (width + gap) + extra + width / 2;
        return this.viewport.clientWidth / 2 - center + drag;
      }
      go(index, animate = true) {
        if (!this.slides || !this.slides.length) return;
        this.index = index;
        if (!animate) this.classList.add('is-jumping');
        this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        this.track.style.transform = `translate3d(${this.offsetFor(index)}px, 0, 0)`;
        if (!animate) {
          void this.track.offsetWidth;
          requestAnimationFrame(() => this.classList.remove('is-jumping'));
        }
      }
      normalize() {
        if (this.count < 2) return;
        if (this.index < this.count) this.go(this.index + this.count, false);
        else if (this.index >= this.count * 2) this.go(this.index - this.count, false);
      }
      next() {
        if (this.count > 1) this.go(this.index + 1);
      }
      prev() {
        if (this.count > 1) this.go(this.index - 1);
      }
      play() {
        this.pause();
        if (!this.autoplayMs || this.count < 2 || this.editorLocked) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = setInterval(() => this.next(), this.autoplayMs);
      }
      pause() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
      }
      onClick(event) {
        if (this.dragged) {
          event.preventDefault();
          event.stopPropagation();
          this.dragged = false;
          return;
        }
        const slide = event.target.closest('[data-fsl-slide]');
        if (!slide) return;
        const index = this.slides.indexOf(slide);
        if (index === -1 || index === this.index) return;
        event.preventDefault();
        this.go(index);
      }
      bindSwipe(signal) {
        let startX = 0;
        let startY = 0;
        let dx = 0;
        let active = false;
        let locked = null;
        this.viewport.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          active = true;
          locked = null;
          startX = event.clientX;
          startY = event.clientY;
          dx = 0;
          this.dragged = false;
          this.pause();
        }, { signal });
        window.addEventListener('pointermove', (event) => {
          if (!active) return;
          const moveX = event.clientX - startX;
          const moveY = event.clientY - startY;
          if (locked === null && (Math.abs(moveX) > 6 || Math.abs(moveY) > 6)) {
            locked = Math.abs(moveX) > Math.abs(moveY) ? 'x' : 'y';
            if (locked === 'x') this.viewport.classList.add('is-dragging');
          }
          if (locked !== 'x') return;
          dx = moveX;
          this.dragged = Math.abs(dx) > 6;
          this.track.style.transform = `translate3d(${this.offsetFor(this.index, dx)}px, 0, 0)`;
        }, { signal });
        const end = () => {
          if (!active) return;
          active = false;
          this.viewport.classList.remove('is-dragging');
          if (locked === 'x') {
            const { width, gap } = this.metrics();
            const threshold = Math.min(60, width / 4);
            if (dx < -threshold) {
              const steps = Math.max(1, Math.round(Math.abs(dx) / (width + gap)));
              this.go(this.index + steps);
            } else if (dx > threshold) {
              const steps = Math.max(1, Math.round(Math.abs(dx) / (width + gap)));
              this.go(this.index - steps);
            } else {
              this.go(this.index);
            }
          }
          locked = null;
          if (this.dataset.pauseHover !== 'true' || !this.matches(':hover')) this.play();
        };
        window.addEventListener('pointerup', end, { signal });
        window.addEventListener('pointercancel', end, { signal });
      }
      onEditorSelect(event) {
        const target = event.target;
        if (!(target instanceof Element) || !this.contains(target)) return;
        if (target === this) return;
        const index = this.slides.indexOf(target.closest('[data-fsl-slide]'));
        if (index === -1) return;
        this.editorLocked = true;
        this.pause();
        this.go(index);
        setTimeout(() => (this.editorLocked = false), 100);
      }
    }
  );
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["museum-request"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('museum-request')) {
  customElements.define(
    'museum-request',
    class MuseumRequest extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-mreq-dialog]');
        this.trigger = this.querySelector('[data-mreq-trigger]');
        this.popupForm = this.querySelector('[data-mreq-popup-form]');
        if (!this.dialog || !this.trigger) return;
        this.trigger.addEventListener('submit', (event) => this.open(event));
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog || event.target.closest('[data-mreq-close]')) this.dialog.close();
        });
        if (this.popupForm) {
          this.popupForm.addEventListener('submit', () => this.fillName());
        }
        if (this.querySelector('[data-mreq-reopen]') && typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        }
      }
      open(event) {
        event.preventDefault();
        const museum = this.querySelector('[data-mreq-museum]');
        if (museum && !museum.value.trim()) {
          museum.setCustomValidity(' ');
          museum.reportValidity();
          museum.setCustomValidity('');
          museum.focus();
          return;
        }
        const popupMuseum = this.querySelector('[data-mreq-popup-museum]');
        if (popupMuseum && museum) popupMuseum.value = museum.value.trim();
        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
          const first = this.querySelector('[data-mreq-first]');
          if (first) first.focus();
        }
      }
      fillName() {
        const first = this.querySelector('[data-mreq-first]');
        const last = this.querySelector('[data-mreq-last]');
        const full = this.querySelector('[data-mreq-full-name]');
        if (full) full.value = [first && first.value.trim(), last && last.value.trim()].filter(Boolean).join(' ');
      }
    }
  );
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review-form-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const holder = () => document.querySelector('[data-jm-holder]');
    const moveModalOut = () => {
      const box = holder();
      if (!box) return;
      box.querySelectorAll('.jdgm-write-review-modal').forEach((modal) => document.body.appendChild(modal));
    };
    const showFallback = () => {
      const dialog = document.querySelector('[data-review-dialog]');
      if (!dialog || dialog.open) return;
      if (dialog.parentElement !== document.body) document.body.appendChild(dialog);
      dialog.showModal();
    };
    let busy = false;
    const open = () => {
      const box = holder();
      if (busy) return true;
      if (!box || (window.jdgmSettings && window.jdgmSettings.disable_web_reviews)) {
        showFallback();
        return true;
      }
      busy = true;
      let tries = 0;
      const attempt = () => {
        const link = box.querySelector('.jdgm-write-rev-link');
        if (link) {
          busy = false;
          link.click();
          setTimeout(moveModalOut, 50);
          setTimeout(moveModalOut, 400);
          return;
        }
        tries += 1;
        if (tries === 1) window.dispatchEvent(new Event('scroll'));
        if (tries < 6) {
          setTimeout(attempt, 250);
          return;
        }
        busy = false;
        showFallback();
      };
      attempt();
      return true;
    };
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-review-open]')) {
        event.preventDefault();
        open();
        return;
      }
      const close = event.target.closest('[data-review-close]');
      if (close) {
        close.closest('dialog').close();
        return;
      }
      if (event.target.matches && event.target.matches('[data-review-dialog]')) event.target.close();
    });
    window.addEventListener(
      'click',
      (event) => {
        const badge = event.target.closest('.jdgm-prev-badge, .jdgm-preview-badge');
        if (!badge || badge.closest('[data-jm-holder]')) return;
        const inner = badge.matches('.jdgm-prev-badge') ? badge : badge.querySelector('.jdgm-prev-badge');
        const count = parseInt((inner && inner.dataset.numberOfReviews) || '0', 10);
        const reviews = document.querySelector('[data-mc-reviews]');
        if (count > 0 && reviews) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const section = reviews.closest('.shopify-section') || reviews;
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        if (count === 0 && document.querySelector('[data-review-dialog]')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          open();
        }
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review-snippets"] && !Shopify.designMode) return;
  try {
    (() => {
    window.mcScroller =
      window.mcScroller ||
      (() => {
        const wrapper = document.querySelector('.page-wrapper');
        if (wrapper && wrapper.scrollHeight > wrapper.clientHeight + 1 && /(auto|scroll)/.test(getComputedStyle(wrapper).overflowY)) return wrapper;
        return document.scrollingElement || document.documentElement;
      });
    window.mcScrollToElement =
      window.mcScrollToElement ||
      ((element, offset) => {
        const scroller = window.mcScroller();
        const isRoot = scroller === document.scrollingElement || scroller === document.documentElement;
        const base = isRoot ? 0 : scroller.getBoundingClientRect().top;
        const top = element.getBoundingClientRect().top - base + scroller.scrollTop - (offset || 0);
        scroller.scrollTo({ top, behavior: 'smooth' });
      });
    if (window.mcScrollReviewsReady) return;
    window.mcScrollReviewsReady = true;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-mc-scroll-reviews]');
      if (!link) return;
      const reviews = document.querySelector('[data-mc-reviews]');
      if (!reviews) return;
      event.preventDefault();
      const target = reviews.closest('.shopify-section') || reviews;
      const bar = document.querySelector('[data-mc-tabs].mc-tabs--visible');
      const offset = bar ? bar.offsetHeight : 0;
      window.mcScrollToElement(target, offset);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
